export default __webpack_public_path__ + "static/media/0xac51c4c48dc3116487ed4bc16542e27b5694da1b.0a329f33.webp";